export default __webpack_public_path__ + "static/media/img-4723.e6fab9d7.jpeg";